let KEYCODE = {
    DOWN: 40,
    LEFT: 37,
    RIGHT: 39,
    SPACE: 32,
    UP: 38
};

window.addEventListener('load', function () {
    let radioButtons = document.querySelectorAll('[role=radio]');

    for (let i = 0; i < radioButtons.length; i++) {
        let rb = radioButtons[i];

        rb.addEventListener('click', clickRadioGroup);
        rb.addEventListener('keydown', keyDownRadioGroup);
        rb.addEventListener('focus', focusRadioButton);
        rb.addEventListener('blur', blurRadioButton);
    }
});

function firstRadioButton(node) {

    let first = node.parentNode.firstChild;

    while (first) {
        if (first.nodeType === Node.ELEMENT_NODE) {
            if (first.getAttribute("role") === 'radio') return first;
        }
        first = first.nextSibling;
    }

    return null;
}

function lastRadioButton(node) {
    let last = node.parentNode.lastChild;

    while (last) {
        if (last.nodeType === Node.ELEMENT_NODE) {
            if (last.getAttribute("role") === 'radio') return last;
        }
        last = last.previousSibling;
    }

    return last;
}

function nextRadioButton(node) {
    let next = node.nextSibling;

    while (next) {
        if (next.nodeType === Node.ELEMENT_NODE) {
            if (next.getAttribute("role") === 'radio') return next;
        }
        next = next.nextSibling;
    }

    return null;
}

function previousRadioButton(node) {

    let prev = node.previousSibling;

    while (prev) {
        if (prev.nodeType === Node.ELEMENT_NODE) {
            if (prev.getAttribute("role") === 'radio') return prev;
        }
        prev = prev.previousSibling;
    }

    return null;
}

function setRadioButton(node, state) {
    if (state === 'true') {
        node.tabIndex = 0;
        node.setAttribute('aria-checked', 'true');
        node.focus();
        $(node).find('input').trigger('click');
        $(node).find('input').attr('checked', 'checked');
    } else {
        node.setAttribute('aria-checked', 'false');
        $(node).find('input').attr('checked', false);
        node.tabIndex = -1;
    }
}

function clickRadioGroup(event) {
    let type = event.type;

    if (type === 'click') {
        // If either enter or space is pressed, execute the funtion

        let node = event.currentTarget;

        let radioButton = firstRadioButton(node);

        while (radioButton) {
            setRadioButton(radioButton, "false");
            radioButton = nextRadioButton(radioButton);
        }

        setRadioButton(node, "true");

        event.preventDefault();
        event.stopPropagation();
    }
}

function keyDownRadioGroup(event) {
    let type = event.type;
    let next = false;

    if (type === "keydown") {
        let node = event.currentTarget;

        switch (event.keyCode) {
            case KEYCODE.DOWN:
            case KEYCODE.RIGHT:
                next = nextRadioButton(node);
                if (!next) next = firstRadioButton(node); //if node is the last node, node cycles to first.
                break;

            case KEYCODE.UP:
            case KEYCODE.LEFT:
                next = previousRadioButton(node);
                if (!next) next = lastRadioButton(node); //if node is the last node, node cycles to first.
                break;

            case KEYCODE.SPACE:
                next = node;
                break;
        }

        if (next) {
            let radioButton = firstRadioButton(node);

            while (radioButton) {
                setRadioButton(radioButton, "false");
                radioButton = nextRadioButton(radioButton);
            }

            setRadioButton(next, "true");

            event.preventDefault();
            event.stopPropagation();
        }
    }
}

function focusRadioButton(event) {
    event.currentTarget.className += ' focus';
}

function blurRadioButton(event) {
    event.currentTarget.className = event.currentTarget.className.replace(' focus', '');
}
